import { AxiosHeaders } from 'axios'
import type { AxiosAdapter, InternalAxiosRequestConfig, Method } from 'axios'

import type {
  AccountDto,
  TransactionDetailDto,
  TransactionFilterOptionsDto,
  TransactionsResponseDto,
} from '@b2b/api'

// TODO(B2B API migration): Delete this module after Account and Transactions
// are backed by env.local routes used by the Customer app.
const account: AccountDto = {
  companyLimit: {
    available: { currency: 'CZK', value: '0' },
    total: { currency: 'CZK', value: '0' },
  },
  installmentLimit: { currency: 'CZK', value: '0' },
}

const transactions: TransactionsResponseDto = {
  data: [
    {
      id: 'pay_001',
      merchant: {
        name: 'SIM Merchant',
        logoUrl: 'https://logo.clearbit.com/amazon.com',
      },
      category: 'FOOD_DRINK',
      amount: { currency: 'CZK', value: '250.00' },
      cashback: { currency: 'CZK', value: '2.50' },
      cashbackStatus: 'CONFIRMED',
      createdAt: '2026-08-12T20:00:00Z',
      status: 'SETTLED',
      shortStatusText: 'Settled',
    },
  ],
  pagination: {
    page: 1,
    pageSize: 20,
    totalItems: 1,
    totalPages: 1,
  },
}

const transactionFilterOptions: TransactionFilterOptionsDto = {
  cards: [],
}

const transactionDetailById: Record<string, TransactionDetailDto> = {
  pay_001: {
    transactionId: 'pay_001',
    merchant: {
      name: 'SIM Merchant',
      logoUrl: 'https://logo.clearbit.com/amazon.com',
    },
    amount: { currency: 'CZK', value: '250.00' },
    orderedAt: '2026-08-12T20:00:00Z',
    shippedAt: '2026-08-12T20:05:00Z',
    orderNumber: '64864442',
    card: {
      id: 'card_001',
      type: 'VIRTUAL',
      label: 'Virtual',
      lastFourDigits: '5456',
    },
  },
}

const normalizeMethod = (method?: Method | string) =>
  (method ?? 'get').toLowerCase()

const pathname = (url?: string) =>
  new URL(url ?? '/', 'http://localhost').pathname

export const getOnboardingApiFallback = ({
  method,
  url,
}: Pick<InternalAxiosRequestConfig, 'method' | 'url'>): unknown => {
  const requestMethod = normalizeMethod(method)
  const requestPath = pathname(url)

  // TODO(B2B legacy API): Remove the `GET /app/account` fallback with its last
  // Customer app consumer.
  if (requestMethod === 'get' && requestPath === '/app/account') {
    return account
  }

  // TODO(B2B legacy API): Remove the `POST /app/transactions` fallback with its
  // last Customer app consumer.
  if (requestMethod === 'post' && requestPath === '/app/transactions') {
    return transactions
  }

  // TODO(B2B legacy API): Remove the `GET /app/transactions/filter` fallback
  // with its last Customer app consumer.
  if (requestMethod === 'get' && requestPath === '/app/transactions/filter') {
    return transactionFilterOptions
  }

  const transactionDetailMatch = requestPath.match(
    /^\/app\/transactions\/([^/]+)$/
  )
  if (requestMethod === 'get' && transactionDetailMatch) {
    const id = transactionDetailMatch[1]
    return (
      transactionDetailById[id] ?? {
        transactionId: id,
        merchant: transactions.data?.[0]?.merchant,
        amount: transactions.data?.[0]?.amount,
        orderedAt: transactions.data?.[0]?.createdAt,
        shippedAt: transactions.data?.[0]?.createdAt,
        orderNumber: '64864442',
      }
    )
  }

  return undefined
}

const createFallbackAdapter =
  (data: unknown): AxiosAdapter =>
  async (config) => ({
    config,
    data,
    headers: new AxiosHeaders(),
    status: 200,
    statusText: 'OK',
  })

export const applyOnboardingApiFallback = (
  config: InternalAxiosRequestConfig
) => {
  const data = getOnboardingApiFallback(config)

  if (data !== undefined) {
    config.adapter = createFallbackAdapter(data)
  }

  return config
}
